module.exports = __webpack_public_path__ + "img/image2019-3-12_17_25_50.6a2bcf82.png";